import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';

Component('tr-member-invite-link', {
  mixins: [eventListenerMixin],

  connected() {
    this.clipboardInput = this.querySelector('.clipboard-text');

    this.initCopyLink();

    $('.btn-reset-invite-token').on('ajax:success', this.resetInviteLink.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  initCopyLink() {
    const link = this.querySelector('#link-copy-text');

    if (document.queryCommandSupported('copy')) link.classList.remove('hide');

    this.listenTo(link, 'click', () => {
      this.clipboardInput.select();
      if (!document.execCommand('copy')) return;

      link.textContent = '复制成功';
      setTimeout(() => {
        link.textContent = '复制';
      }, 2000);
    });
  },

  resetInviteLink(event, result) {
    if (result.success) {
      this.clipboardInput.value = result.invite_join_url;
      window.tower.highlight(this.clipboardInput);
    }
  },
});
